import script from "./GlobalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalContent.vue?vue&type=script&setup=true&lang=js"

import "./GlobalContent.vue?vue&type=style&index=0&id=13d9361f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d9361f"]])

export default __exports__